<template lang="html">
	<div class="patrimonial-form">
		<form class="form-ui landscape-patrimonial-ui" novalidate>
			<div class="ctn-toggle row">
				<div class="label">
					Possédez-vous une épargne ?
				</div>
				<custom-toggle :value="isSavings" @change="isSavings=$event"/>
			</div>
			<div v-if="isSavings">
				<div class="ctn-add-children row">
					<custom-select :solo="true" :object="true" :items="savingsData" :selected="typeToAdd" @change="typeToAdd=$event"/>
					<div class="btn-add" @click="addSaving">
						<span class="icon-form-plus"></span>
					</div>
				</div>
				<div class="ctn-childrens">
					<div class="ctn-children" v-for="(saving, key) in savingsRow" v-bind:key="key">
						<div class="type-children row">
							{{ saving.type }} <div class="link" @click="removeSaving(key)">supprimer</div>
						</div>
						<div class="form-elem-container row">
							<div class="ctn-input ctn-label three" :class="{error: errors.has('montant' + (key + 1))}">
								<label :for="'montant' + (key + 1)">Montant actuel</label>
								<input type="text" :name="'montant' + (key + 1)" v-model="saving.fields.value" :key="'amount' + key">
								<custom-select :items="currencies" :selected="saving.fields.currency" @change="saving.fields.currency=$event"/>
							</div>
							<div class="error-message">{{ errors.first('montant' + (key + 1))}}</div>
						</div>
						<div class="form-elem-container row" v-if="saving.fields.opening_date != null">
							<div class="ctn-input ctn-label" :class="{error: errors.has('date d\'ouverture' + (key + 1))}">
								<label :for="'date d\'ouverture' + (key + 1)">Date d'ouverture</label>
								<input type="date" :name="'date d\'ouverture' + (key + 1)" v-model="saving.fields.opening_date" :key="'opening' + key">
							</div>
							<div class="error-message">{{ errors.first('date d\'ouverture' + (key + 1))}}</div>
						</div>
						<div class="form-elem-container row" v-if="saving.fields.ownership_type != null">
							<div class="ctn-input ctn-label">
								<label>Type de propriété</label>
								<custom-select :items="ownershipTypes" v-model="saving.fields.ownership_type"></custom-select>
							</div>
							<div class="error-message"></div>
						</div>
						<div class="form-elem-container row" v-if="saving.fields.investment_name != null">
							<div class="ctn-input ctn-label" :class="{error: errors.has('nom de l\'investissement' + (key + 1))}">
								<label for="nom de l'investissement">Nom du contrat</label>
								<input type="text" :name="'nom de l\'investissement' + (key + 1)" v-model="saving.fields.investment_name" :key="'investmentName' + key">
							</div>
							<div class="error-message">{{ errors.first('nom de l\'investissement' + (key + 1))}}</div>
						</div>
						<div class="form-elem-container row" v-if="saving.fields.bank_name != null">
							<div class="ctn-input ctn-label" :class="{error: errors.has('nom de la banque' + (key + 1))}">
								<label for="nom d la banque">Nom de l'établissement</label>
								<input type="text" :name="'nom de la banque' + (key + 1)" v-model="saving.fields.bank_name" :key="'bankName' + key">
							</div>
							<div class="error-message">{{ errors.first('nom de la banque' + (key + 1))}}</div>
						</div>
					</div>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
import CustomSelect from '@/common/components/Form/CustomSelect'
import CustomToggle from '@/common/components/Form/CustomToggle'
import Savings from '@/common/components/MyPatrimonialLandscape/data/Savings'
import Currency from '@/common/components/MyPatrimonialLandscape/data/Currency'
import PropertyType from '@/common/components/MyPatrimonialLandscape/data/PropertyTypes'
// import { resolveDate } from '@/common/services/ResolveDate'
import { mapGetters } from 'vuex'

class Saving {
	constructor (saving, position = 0) {
		this.type = saving.type
		this.fields = {
			value: null,
			currency: 'EUR',
			position: position
		}
		saving.fields.forEach((field) => {
			this.fields[field] = ''
		})
	}
}

export default {
	name: 'Savings',
	components: {
		CustomSelect,
		CustomToggle
	},
	data () {
		return {
			currencies: Currency,
			ownershipTypes: PropertyType,
			isSavings: false,
			savingsData: Savings,
			typeToAdd: Savings[0],
			savingsRow: []
		}
	},
	mounted () {
		console.log('SAVINGS - mounted')
		this.initializeSavings()
	},
	methods: {
		initializeSavings () {
			this.savingsRow = this.$iRobot.cloneDeep(this.estate.savings)
			this.isSavings = (this.savingsRow.length > 0)
			this.savingsRow.forEach((saving, index) => {
				if (saving.fields.opening_date) {
					saving.fields.opening_date = this.formatDate(saving.fields.opening_date)
				}

				if (saving.fields.position < 0) {
					saving.fields.position = index
				}
			})
			console.log(this.savingsRow)
		},

		addSaving () {
			let position = this.savingsRow.length > 0 ? this.savingsRow[this.savingsRow.length - 1].fields.position + 1 : 0
			this.savingsRow.push(new Saving(this.typeToAdd, position))
		},
		removeSaving (key) {
			this.savingsRow.splice(key, 1)
		},
		validate () {
			return this.$validator.validate()
		},
		save () {
			return new Promise((resolve, reject) => {
				this.validate().then((validation) => {
					if (validation) {
						let foo = (this.isSavings) ? this.savingsRow : []
						this.$store.dispatch('storePatrimonial', {
							name: 'SAVINGS',
							data: foo,
							fromStart: false
						}).then(() => {
							resolve()
							this.refreshDataSaved()
						})
					}
				})
			})
		},
		refreshDataSaved () {
			// setTimeout(() => {
			this.initializeSavings()
			// }, 10000)
		},
		formatDate (d) {
			if (d.indexOf(':') !== -1) {
				let d1 = d.split(' ')
				d1 = d1[0].split('/')
				d1 = d1.reverse().join('-')
				return d1
			} else {
				return d
			}
		}
	},
	beforeDestroy () {
		this.save()
	},
	computed: {
		...mapGetters({
			estate: 'estate'
		})
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/common/components/MyPatrimonialLandscape/Savings.vue